import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

declare var Flickity: any;

@Component({
  selector: 'app-solution',
  templateUrl: './solution.component.html',
  styleUrls: ['./solution.component.scss']
})
export class SolutionComponent implements AfterViewInit, OnInit {

  constructor(private el: ElementRef, private router: Router) { }

  ngOnInit(): void {

  }
  ngAfterViewInit(): void {

    const el = this.el.nativeElement;

    const elem = el.querySelector('.carousel');
    new Flickity(elem, {
      wrapAround: true,
      contain: true,
      autoPlay: 2500,
    });

  }

  goto_power_monitoring() {
    this.router.navigate(["./solution/power-monitoring"])
  }
  goto_agricultural() {
    this.router.navigate(["./solution/agricultural"])
  }
  goto_smarthome() {
    this.router.navigate(["./solution/smarthome"])
  }
  goto_cam() {
    this.router.navigate(["./solution/security-cam"])
  }

}
